import _ from "lodash";
import {
  FETCH_USER_IMPC_SELECTIONS_SUCCESS,
  SAVE_USER_IMPC_SELECTION_REQUEST,
  DELETE_USER_IMPC_SELECTION_REQUEST,
  FETCH_USER_OPERATOR_SELECTIONS_SUCCESS,
  SAVE_USER_OPERATOR_SELECTION_REQUEST,
  DELETE_USER_OPERATOR_SELECTION_REQUEST,
} from "../../../../user/redux/actions/types/UserActionTypes";
import { ENTERED_WIZARD } from "../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes";
import postalOperatorsMapper from "../mappers/postalOperatorsMapper";
import {
  DEPARTURE_MAIL_PROCESSING_CENTER_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED,
  DESELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_SUCCESS,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_FAILURE,
  SELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_DEPARTURE_OPERATORS,
  DESELECT_ALL_DEPARTURE_OPERATORS,
  DEPARTURE_OPERATOR_CENTER_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_ADMIN,
} from "../actions/types/DeparturePostalOperatorActionTypes";
import filterIMPCCodesIfExistsInPostalOperators from "../filters/filterIMPCCodesIfExistsInPostalOperators";
import { SWITCH_DEPARTURE_ARRIVAL } from "../actions/types/PostalOperatorActionTypes";
import OperatorTypes from "../../../../common/redux/actions/types/OperatorTypes";
import { LOGGED_OUT } from "../../../../../core/modules/security/redux/actions/types/SecurityActionTypes";
import operatorsMapper from "../mappers/operatorsMapper";
import filterOperatorCodesIfExistsInPostalOperators from "../filters/filterOperatorCodesIfExistsInPostalOperators";
import {
  DELETE_GLOBAL_SELECTION_IMPC_REQUEST,
  DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST,
  SAVE_GLOBAL_SELECTION_IMPC_REQUEST,
  SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST,
} from "../../../../admin/dashboard/redux/actions/types/AdminDashboardActionTypes";

export const initialState = {
  nodes: [],
  nodesForOperator: [],
  checkedMailProcessingCenters: [],
  checkedOperator: [],
  expandedPostalOperators: [],
  expandedPostalOperatorsOperatorImpcAdmin: [],
  selections: [],
  isLoading: false,
};

const allChildNodeValues = (nodes) =>
  nodes
    .map((node) => node.children.map((mPC) => mPC.value))
    .reduce((initial, impcCodes) => initial.concat(impcCodes));

const handleUserIMPCSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, {
    name: action.payload.selectionName,
  });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    impcCodes: action.payload.selectedIMPCCodes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminIMPCSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, {
    name: action.payload.selectionName,
  });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    impcCodes: action.payload.selectedIMPCCodes,
    scope: "GLOBAL",
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminOperatorSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, {
    name: action.payload.selectionName,
  });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    operatorCodes: action.payload.selectedIMPCCodes,
    scope: "GLOBAL",
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserOperatorSelectionRequest = (action, state) => {
  const selections = [...state.selections];
  const indexOfExistingSelection = _.findIndex(selections, {
    name: action.payload.selectionName,
  });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    operatorCodes: action.payload.selectedIMPCCodes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserIMPCSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter((item) => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminIMPCSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter((item) => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminOperatorSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter((item) => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

// eslint-disable-next-line no-unused-vars
const handleAdminMrdImpcSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter((item) => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const departurePostalOperatorsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_USER_IMPC_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.DEPARTURE) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map((selection) => ({
              ...selection,
              name:
                selection.name === "LAST_SELECTION"
                  ? "Your last selection"
                  : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case FETCH_USER_OPERATOR_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.DEPARTURE) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map((selection) => ({
              ...selection,
              name:
                selection.name === "LAST_SELECTION"
                  ? "Your last selection"
                  : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_SUCCESS:
      return {
        ...state,
        nodes: postalOperatorsMapper(action.payload),
        nodesForOperator: operatorsMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_OUTBOUND_POSTAL_OPERATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case DEPARTURE_MAIL_PROCESSING_CENTER_CHECKED:
      return {
        ...state,
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          action.checkedMailProcessingCenters,
          state.nodes,
          action.reportDefinition
        ),
        checkedOperator: filterOperatorCodesIfExistsInPostalOperators(
          action.checkedMailProcessingCenters,
          state.nodesForOperator
        ),
      };
    case DEPARTURE_OPERATOR_CENTER_CHECKED:
      return {
        ...state,
        checkedOperator: filterOperatorCodesIfExistsInPostalOperators(
          action.checkedMailProcessingCenters,
          state.nodesForOperator
        ),
      };
    case DEPARTURE_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedPostalOperators: [...action.expandedPostalOperators],
      };
    case DEPARTURE_POSTAL_OPERATOR_EXPANDED_ADMIN:
      return {
        ...state,
        expandedPostalOperatorsOperatorImpcAdmin: [
          ...action.expandedPostalOperatorsOperatorImpcAdmin,
        ],
      };
    case SELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: allChildNodeValues(action.payload.nodes),
      };
    case SELECT_ALL_DEPARTURE_OPERATORS:
      return {
        ...state,
        checkedOperator: action.payload.nodes.map((node) => node.value),
      };
    case DESELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    case DESELECT_ALL_DEPARTURE_OPERATORS:
      return {
        ...state,
        checkedOperator: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_IMPC_SELECTION_REQUEST:
      return handleUserIMPCSelectionRequest(action, state);
    case SAVE_USER_OPERATOR_SELECTION_REQUEST:
      return handleUserOperatorSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_OPERATOR_REQUEST:
      return handleAdminOperatorSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_IMPC_REQUEST:
      return handleAdminIMPCSelectionRequest(action, state);
    case DELETE_USER_IMPC_SELECTION_REQUEST:
      return handleUserIMPCSelectionDeleteRequest(action, state);
    case DELETE_USER_OPERATOR_SELECTION_REQUEST:
      return handleUserIMPCSelectionDeleteRequest(action, state);
    case DELETE_GLOBAL_SELECTION_OPERATOR_REQUEST:
      return handleAdminOperatorSelectionDeleteRequest(action, state);
    case DELETE_GLOBAL_SELECTION_IMPC_REQUEST:
      return handleAdminIMPCSelectionDeleteRequest(action, state);
    case SWITCH_DEPARTURE_ARRIVAL:
      return {
        ...state,
        ...action.payload.arrival,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
